import ListHeader, { ListHeaderProps } from './ListHeader.component';

export type ListHeaderType = ListHeaderProps;

export default ListHeader;
